export default {
  querenshanchutoupiao: '确认删除次投票吗？',
  jieduantianjia: '由{phase}阶段添加',
  huifushuliang: '{num}条回复',

}